export default __webpack_public_path__ + "static/media/jim-and-pam.26ab3a81.gif";